import {
  TextBase,
  Icon,
  Box,
  Flex,
  styled,
  TextField,
  UnstyledButton,
} from '@chilipiper/design-system'

export const StyledScrollButton = styled(UnstyledButton)`
  opacity: 0.8;
  transform: translate(-50%, 0);
  transition: all 0.15s ease;
  width: auto;
  display: flex;

  ${TextBase} {
    width: 0px;
    height: 0px;
    visibility: hidden;
    white-space: nowrap;
  }

  &:hover {
    padding: ${props => props.theme.sizes[2]} ${props => props.theme.sizes[4]};
    ${TextBase} {
      width: 80px;
      height: auto;
      visibility: visible;
      margin-left: ${props => props.theme.sizes[2]};
    }
  }
`

export const StyledArrowIcon = styled(Icon)`
  transform: rotate(-90deg);
`

export const StyledTextField = styled(TextField)`
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  &:not(:focus-within) {
    box-shadow: ${props => props.theme.shadows['box-neutral-default']};
    input {
      box-shadow: none;
    }
  }
`

export const StyledWorkspace = styled(Box)`
  &:first-child {
    & > ${Flex} {
      box-shadow: ${props => props.theme.shadows['box-neutral-default-x-divider']},
        ${props => props.theme.shadows['box-neutral-default-bottom-divider']};
    }
  }
`
